import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import type { ICellRendererParams } from "ag-grid-enterprise";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) =>
	createStyles({
		assetLink: {
			color: theme.palette.primary.main,
			cursor: "pointer",
			textDecoration: "none",
			fontSize: "0.875rem",
			width: "100%",
			display: "block",
			textAlign: "center",
			"&:hover": {
				textDecoration: "underline",
			},
		},
		assetText: {
			cursor: "default",
			fontSize: "0.875rem",
			width: "100%",
			display: "block",
			textAlign: "center",
		},
	}),
);

const getCompactPath = (fullPath: string) => {
	if (!fullPath) return "";
	const parts = fullPath.split("/");
	if (parts.length <= 3) return fullPath;
	return `${parts[0]}/.../${parts[parts.length - 2]}/${parts[parts.length - 1]}`;
};

export const AssetNameRenderer = (params: ICellRendererParams) => {
	const { value, data } = params;
	const classes = useStyles();
	const navigate = useNavigate();
	const {
		state: { currentGridName, assetSearchId },
	} = useAssetDetailsContext();

	const handleAssetClick = (assetId: string | number) => {
		navigate(
			`/asset-details/${assetId}?resource=${currentGridName}&assets=true&statistics=true&workOrders=true`,
		);
	};

	const compactPath = getCompactPath(data?.AssetFullPath || "");
	const displayText = compactPath || value || "";

	if (data?.AssetId) {
		const isCurrentAsset =
			data.AssetId.toString() === assetSearchId?.toString();

		if (isCurrentAsset) {
			return (
				<span title={data?.AssetFullPath || ""} className={classes.assetText}>
					{displayText}
				</span>
			);
		} else {
			return (
				<span
					title={data?.AssetFullPath || ""}
					className={classes.assetLink}
					onClick={() => handleAssetClick(data.AssetId)}
				>
					{displayText}
				</span>
			);
		}
	} else {
		return (
			<span title={data?.AssetFullPath || ""} className={classes.assetText}>
				{displayText}
			</span>
		);
	}
};
